export default "__VITE_ASSET__BUt9lofc__"